import { Image } from '@chakra-ui/image';
import { FlexProps } from '@chakra-ui/layout';
import React from 'react';

import {
    Container, Title
} from './button.styled';
import arrowIcon from './icons/arrow.svg';
import threeEssentialsIcon from './icons/three-essentials.svg';

type ButtonProps = {
title: string
clickHandler?: () => void
icon?: string
overrideStyles?: FlexProps
hideThreeEssentialsIcon?: boolean
};

export const Button = ({
    title, clickHandler, icon, overrideStyles, hideThreeEssentialsIcon
}: ButtonProps) => {
    return (
        <Container onClick={clickHandler} {...overrideStyles}>
            { !hideThreeEssentialsIcon && <Image src={icon || threeEssentialsIcon} h={'30px'} /> }
            <Title>{title}</Title>
            <Image src={arrowIcon} h={'30px'} />
        </Container>
    );
};
